import { booleanAttribute } from "#ce/utils/props";

// `value` is absent on purpose: the element owns a live `value` property, which a declared prop
// would shadow with an accessor onto the prop store. The attribute seeds it and names the reset value.
export const props = Object.freeze({
  /**
   * Minimum value of the range.
   *
   * @type {Number}
   * @default 1
   * @storybook-control number
   */
  min: {
    type: Number,
    default: 1,
  },
  /**
   * Maximum value of the range.
   *
   * @type {Number}
   * @default 12
   * @storybook-control number
   */
  max: {
    type: Number,
    default: 12,
  },
  /**
   * Step increment between selectable values. Determines the number of ticks when show-ticks is enabled.
   *
   * @type {Number}
   * @default 1
   * @storybook-control number
   */
  step: {
    type: Number,
    default: 1,
  },
  /**
   * Show small vertical tick marks above the track at each step boundary.
   *
   * @type {Boolean|String}
   * @default true
   */
  showTicks: booleanAttribute(true),
  /**
   * Size of an individual tick mark. Accepts a CSS length string.
   *
   * @type {String|Number}
   * @default "8px"
   */
  tickSize: {
    type: [String, Number],
    default: "8px",
  },
  /**
   * Accessible name for the slider. A visible label outside this element cannot name the
   * control inside its shadow root, so pass the label's text here.
   *
   * @type {String}
   */
  accessibleName: {
    type: String,
    default: undefined,
  },
  /**
   * What a screen reader announces for the current value, such as "25 miles". Omitted, it
   * announces the number.
   *
   * @type {String}
   */
  valueText: {
    type: String,
    default: undefined,
  },
  /**
   * Disable the slider so it ignores input.
   *
   * @type {Boolean|String}
   * @default false
   */
  disabled: booleanAttribute(),
});
